
import FacebookIcon from "../../../../assets/images/icons/facebook-icon.png"
import InstagramIcon from "../../../../assets/images/admin/Instagram.png"
import XIcon from "../../../../assets/images/icons/x.svg";
import TikTokIcon from "../../../../assets/images/admin/Tiktok.png";
import YoutubeIcon from "../../../../assets/images/admin/Youtube.png";
import SpotifyIcon from "../../../../assets/images/admin/Spotify.svg";
import SoundCloudIcon from "../../../../assets/images/icons/soundcloud.svg";
import EmailIcon from "../../../../assets/images/admin/email.svg";

export const socialPlatformsArray = [
  {
    id: 1,
    name: "Facebook",
    icon: FacebookIcon,
    url: "",
    bgColor: "bg-blue-100",
    width: "w-[42px]",
    enabled: true,
    type: "default",
  },
  {
    id: 2,
    name: "Instagram",
    icon: InstagramIcon,
    url: "",
    bgColor: "bg-red-100",
    width: "w-[38px]",
    enabled: true,
    type: "default",
  },
  {
    id: 3,
    name: "TikTok",
    icon: TikTokIcon,
    url: "",
    bgColor: "bg-gray-200",
    width: "w-[34px]",
    enabled: true,
    type: "default",
  },
  {
    id: 4,
    name: "Twitter",
    icon: XIcon,
    url: "",
    bgColor: "bg-gray-300",
    width: "w-[32px]",
    enabled: true,
    type: "default",
  },
  {
    id: 5,
    name: "YouTube",
    icon: YoutubeIcon,
    url: "",
    bgColor: "bg-red-200",
    width: "w-[34px]",
    enabled: true,
    type: "default",
  },
  {
    id: 6,
    name: "Spotify",
    icon: SpotifyIcon,
    url: "",
    bgColor: "bg-[#1DB954]/20",
    width: "w-[38px]",
    enabled: true,
    type: "default",
  },
  {
    id: 7,
    name: "SoundCloud",
    icon: SoundCloudIcon,
    url: "",
    bgColor: "bg-[#FFDFC4]",
    width: "w-[34px]",
    enabled: true,
    type: "default",
  },
//   {
//     id: 8,
//     name: "Email",
//     icon: EmailIcon,
//     url: "",
//     bgColor: "bg-purple-200",
//     width: "w-[38px]",
//     enabled: true,
//     type: "default",
//   },
];